module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./node_modules/can-namespace/can-namespace.js
// module id = tO5U
// module chunks = 34